import jsonLogic from "json-logic-js";
export default function(value, expr){
    if(value == null){
        return false;
    }
    if(!Array.isArray(value)){
        value = [value];
    }
    let rule = JSON.parse(expr);
    let resp = false;
    for(let val of value){
        resp = jsonLogic.apply(rule, val);
        if(resp){
            break;
        }
    }
    return resp;
}
